<h1 mat-dialog-title class="dialog-title">
  <mat-icon>person_add</mat-icon>
  <span>Vincular Vendedor</span>
</h1>

<div mat-dialog-content class="dialog-content">
  <p>Selecione o vendedor responsável:</p>
  <mat-form-field appearance="outline" class="w-100">
    <mat-label>Vendedor</mat-label>
    <mat-select [(ngModel)]="selectedVendedorId">
      @for (vendedor of vendedores; track vendedor.id) {
        <mat-option [value]="vendedor.id">
          {{ vendedor.descricao }}
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>

<div mat-dialog-actions align="end" class="mat-mdc-dialog-actions">
  <button mat-stroked-button class="btn-secondary" (click)="cancelar()">Cancelar</button>
  <button mat-flat-button class="btn-primary" [disabled]="!selectedVendedorId" (click)="confirmar()">
    Salvar
  </button>
</div>
